import { ScheduleStatus } from "pages/schedules/Constants/schedulesConstants"
import { ShiftInterface } from "./workMonitor.types"
import { GetEmployeeInterface } from "./employees.types"
import { GetAllLocationDetailsInterface, GetLocationDetailsInterface } from "./locations.types"
import { SDEventTypes } from "./staticData.types"
import { ShiftPublicationStatusEnum } from "config/constants"

export interface LocationInterface {
	_id: string
	name: string
	branch: string
}
export interface CreateSchedulesInterface {
	location: string
	post: string
	startTime: string
	finishTime: string
	date: string
	employee?: string
	user: string
	createMultiple?: string
	checkMultiple?: boolean
	notes?: string
	branch?: string
	supplier?: string
	bypassSiaVerification?: boolean
	bypassMaxConsecutiveWorkdaysVerification?: boolean
	eventType: string
}

export interface GetSchedulesObjectInterface extends GetSchedulesInterface {
	data: GetSchedulesInterface
}
export interface GetSchedulesInterface
	extends Omit<CreateSchedulesInterface, "location" | "post" | "employee" | "eventType"> {
	_id: string
	employee: Partial<GetEmployeeInterface>
	deletedAt: Date | null
	status?: ScheduleStatus
	shift?: ShiftInterface
	site: Partial<GetAllLocationDetailsInterface>
	isFourOnFourOff?: boolean
	post: {
		_id: string
		name: string
	}
	publicationStatus: ShiftPublicationStatusEnum
	runningLate: boolean
	createdFromRecur?: string
	eventType: Partial<SDEventTypes>
}

export interface UpdatedSchedulesInterface extends Omit<CreateSchedulesInterface, "location"> {
	location: LocationInterface
}
export interface UpdateSchedulesInterface extends Omit<CreateSchedulesInterface, "date"> {
	ids: string[] | { _id: string; startTime: string; finishTime: string }[]
	dates: string[]
}

export interface AllocateEmployeeToScheduleInterface {
	ids: string[]
	employee: string
	notes: string
}

export interface AllocateScheduleInterface {
	employee: string
	branch?: string
	supplier?: string
	blowout?: boolean
	notes?: string
	bypassSiaVerification?: boolean
	bypassMaxConsecutiveWorkdaysVerification?: boolean
	allocateEvents?: boolean
}

export interface ScheduleFilterInterface {
	state: string
	startTime: string
	finishTime: string
	maxRows: number
	branch: string
}
export interface DeleteEmployeeToScheduleInterface {
	ids: string[]
	notes: string
}

export interface FilterEmployeeFromSupplierOrBranchInterface {
	filterId: string
	filterFrom: string
}
export interface FilterEmployeeFromMultipleSupplierOrBranchInterface {
	filterId: string[]
	filterFrom: "branch" | "supplier" | ""
}

export interface GetScheduleFromTableInterface {
	date: string
	finishTime: string
	startTime: string
	isDeleted: boolean
	site: Partial<GetLocationDetailsInterface>
	name: string
	employeeName?: string
	onMouseDown: () => void
	onMouseDrag: () => void
	post: {
		_id: string
		name: string
	}
	shift: ShiftInterface
	status: string
	publicationStatus: ShiftPublicationStatusEnum
	eventType: Partial<SDEventTypes>
	employee: string
	updatedAt: string
	user: string
	_id: string
	isFourOnFourOff?: boolean
}

export interface SelectedSchedules {
	[key: string]: GetScheduleFromTableInterface | null
}

export enum ScheduleTabs {
	BySite = "by-site",
	ByEmployee = "by-employee",
	ByFilter = "by-filter",
	Planner = "planner",
}

export enum EmployeeTabs {
	Detail = "detail",
	Service = "service",
	HR = "hr",
	Holidays = "holidays",
	Sickness = "sickness",
	Terms = "terms",
	Location = "location",
	Equipments = "equipments",
	Documents = "documents",
	AdditionalDetail = "additional-detail",
	Qualifications = "qualifications",
	PayCodes = "pay-codes",
	Addresses = "addresses",
}

export enum LocationTabs {
	Detail = "detail",
	Escalations = "escalations",
	Contracts = "contracts",
	Posts = "posts",
	Qualifications = "qualifications",
	TimeCaptures = "time-captures",
	AdditionalDetail = "additional-detail",
	Documents = "documents",
	QRCodes = "qr-codes",
	Incidents = "incidents",
	Complaints = "complaints",
}

export interface SchedulesQueryParams {
	location_branch?: string
	employee_branch?: string
	customer?: string
	supplier?: string
	location?: string
	employee?: string
	tab?: ScheduleTabs | EmployeeTabs | LocationTabs
	contract?: string
	date?: string // Format: YYYY-MM-DD
	schedule?: string
	selected?: string
	activeOnly?: string
}
